<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12Xoksm/tc-custom/9783988263322.jpg?1704424798111" alt="This image is the cover for the book Larry Dexter, Reporter, or, Strange Adventures in a Great City, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Larry Dexter, Reporter, or, Strange Adventures in a Great City, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Larry Dexter, Reporter is a novel by Howard Roger Garis. The story follows young journalist Larry Dexter as he begins his career at the Daily Eagle. Larry is eager to prove himself as a top-notch reporter and embarks on a series of adventures as he chases stories and tries to uncover the truth. Along the way, he makes friends and enemies, deals with romantic entanglements, and battles corruption in the city. The book provides a vivid and entertaining portrait of the world of newspaper journalism in the early 20th century.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Howard Roger Garis
      </h2>
      
      <p class="authorDescription body article">Howard Roger Garis (1873-1962) was an American author and newspaper writer, best known for his children's books featuring the character of Uncle Wiggily Longears. He was born in Binghamton, New York, and grew up in Newark, New Jersey. Garis began his career as a newspaper reporter and editor, working for several newspapers in Newark and New York City. In 1910, he began writing stories for children, creating the character of Uncle Wiggily, an elderly rabbit with a limp who goes on various adventures and helps other animals in need. The Uncle Wiggily series proved to be incredibly popular, with over 70 books and numerous short stories published over the course of several decades. Garis also wrote other children's series, including the "Bedtime Stories" and "Sammie and Susie Littletail" books. In addition to his work as a writer, Garis was also involved in radio broadcasting. He wrote scripts for several radio programs, including "Let's Pretend" and "The Adventures of Uncle Wiggily," which aired on NBC from 1937 to 1950. Howard Roger Garis's contributions to children's literature were significant, and his books remain popular with young readers today. His work helped to popularize the idea of animal characters in children's literature, and his use of simple language and engaging stories made his books accessible to children of all ages.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e463f2a